module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1049.d95faf79.png";